"use client";
import { useEffect, useState } from "react";

export const LiveCountdown = ({ date }: { date: Date | string }) => {
	const [now, setNow] = useState(new Date());
	useEffect(() => {
		const interval = setInterval(() => {
			setNow(new Date());
		}, 500);
		return () => clearInterval(interval);
	}, []);

	const targetDate = new Date(date);
	const diff = targetDate.getTime() - now.getTime();

	if (diff <= 0) {
		return null;
	}

	const days = Math.floor(diff / (1000 * 60 * 60 * 24));
	const hours = Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
	const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
	const seconds = Math.floor((diff % (1000 * 60)) / 1000);

	const parts = [
		[days, "days"],
		[hours, "hours"],
		[minutes, "minutes"],
		[seconds, "seconds"],
	] as const;

	// skip leftmost 0 values
	const firstNonZero = parts.findIndex(([value]) => value > 0);
	const partsToDisplay = parts.slice(firstNonZero);

	return (
		<span className="tabular-nums">
			{partsToDisplay.map(([value, unit]) => (
				<span key={unit}>
					<span className="w-[2ch] inline-block text-right">{value}</span>{" "}
					<span className="inline-block">{unit}</span>{" "}
				</span>
			))}
		</span>
	);
};
